import request from "@/utils/request";

// 获取购物车列表
export function getCartList(data) {
  return request({
    method: "post",
    path: "cart/lists",
    data,
  });
}

//获取购物车所有列表
export function getAllCartList(data) {
  return request({
    method: "post",
    path: "cart/all",
    data,
  });
}

// 删除购物车
export function deleteCart(data) {
  return request({
    method: "post",
    path: "cart/delete",
    data,
  });
}


// 根据编码获取商品
export function getProductByNo(data) {
  return request({
    method: "post",
    path: "cart/getProductByNo",
    data,
  });
}

// 批量添加购物车
export function addCartMulti(data) {
  return request({
    method: "post",
    path: "cart/addMulti",
    data,
  });
}
